<div class="main-container-wrapper">
    <div class="main-container">
        <div class="title-container">
            <h1 class="title">Liste des contrats</h1>
            <div class="year-picker-and-button-container">
                <!-- year -->
                <custom-year-picker
                        styleType="rounded"
                        [selectedYear]="contractYear"
                        [disabled]="isYearPickerDisabled"
                        [minYear]="contractYear"
                        [maxYear]="contractYear"
                        (yearSelected)="handleYearDatepickerValueChange($event)">
                </custom-year-picker>
                <button
                        class="tv-ns-primary-large-button-on-light-bg"
                        (click)="onContractCreateButtonClick()">
                    Créer un contrat
                </button>
            </div>
        </div>

        <div class="light-flex-card">
            <!-- filters -->
            <div class="filters-and-table-container">
                <div class="table-search-export-container">
                    <!-- search -->
                    <div class="tv-round-input-extensible-no-label width-300px">
                        <mat-form-field>
                            <mat-label>Chercher</mat-label>
                            <mat-icon matPrefix>search</mat-icon>
                            <input matInput [formControl]="searchFormControl" name="search"
                                   (keyup.enter)="addSearchTerm()"/>
                            <button *ngIf="searchFormControl.value"
                                    matSuffix
                                    type="button"
                                    aria-label="Effacer la recherche"
                                    class="tv-clear-input-icon-button"
                                    (click)="clearSearchInput()">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <!-- choose column -->
                    <app-filter-popup [onFilterItemClick]="applyFilterToTable"
                                      [filterItems]="allDisplayedColumns"></app-filter-popup>
                </div>

                <mat-chip-set *ngIf="searchTerms.length > 0" class="tv-chip-dark-square"
                              aria-label="Termes de recherche">
                    <mat-chip *ngFor="let term of searchTerms">
                        {{ term }}
                        <button type="button" matChipRemove [attr.aria-label]="'Supprimer le filtre ' + term"
                                (click)="removeSearchTerm(term)">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                </mat-chip-set>


                <!-- table -->
                <div class="div-table-container tv-custom-always-visible-scroll-bar">
                    <table
                            *ngIf="!isLoadingItems; else loading"
                            mat-table
                            [dataSource]="items"
                            class="tv-ns-mat-table table"
                            matSort
                            (matSortChange)="sortData($event)"
                            matSortActive="name"
                            matSortDisableClear
                            matSortDirection="asc">

                        <!-- Numero Client -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell
                                *matHeaderCellDef
                                class="mat-header-cell-center-align font-ns"
                                mat-sort-header="id"
                                sortActionDescription="Sort by name">
                                Numéro Client
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.clientId }}
                            </td>
                        </ng-container>

                        <!-- Nom Client -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell
                                *matHeaderCellDef
                                class="mat-header-cell-center-align font-ns"
                                mat-sort-header="name"
                                sortActionDescription="Sort by name">
                                Nom Client
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.clientName }}
                            </td>
                        </ng-container>

                        <!-- Agence -->
                        <ng-container matColumnDef="centralAgency">
                            <th mat-header-cell
                                *matHeaderCellDef
                                class="mat-header-cell-center-align font-ns"
                                mat-sort-header="centralAgencyName"
                                sortActionDescription="Sort by name">
                                Agence
                            </th>
                            <td mat-cell
                                *matCellDef="let item"
                                class="icon-cell"
                                [ngClass]="{
                                    'agency-active': item.centralAgency?.temActif === 'Y',
                                    'agency-inactive': item.centralAgency?.temActif === 'N'
                                }"
                                (click)="onIconClick(item)">
                                {{ item.centralAgency?.name || '-' }} ({{ item.centralAgency?.id || '-' }})
                            </td>
                        </ng-container>

                        <!-- Commercial -->
                        <ng-container matColumnDef="contractManager">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">
                                Commercial
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.contractManager?.name || '-' }} ({{ item.contractManager?.id || '-' }})
                            </td>
                        </ng-container>

                        <!-- Statut Annonceur -->
                        <ng-container *ngIf="allDisplayedColumns['cgvStatus']" matColumnDef="cgvStatus">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">Statut
                                Annonceur
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.cgvLabel }}
                            </td>
                        </ng-container>

                        <!-- Libelle CGV Contrat -->
                        <!--                        <ng-container matColumnDef="cgvLabel">-->
                        <!--                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">Libelle-->
                        <!--                                CGV Contrat-->
                        <!--                            </th>-->
                        <!--                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">-->
                        <!--                                {{ item.cgvLabel }}-->
                        <!--                            </td>-->
                        <!--                        </ng-container>-->

                        <!-- Etat du contrat -->
                        <ng-container matColumnDef="stateContractLabel">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">Etat du
                                contrat
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.stateContractLabel }}
                            </td>
                        </ng-container>

                        <!-- CA -->
                        <ng-container matColumnDef="CA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.CA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <!-- Date Retour -->
                        <ng-container *ngIf="allDisplayedColumns['cgvReturnDate']" matColumnDef="cgvReturnDate">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">Date
                                Retour
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.cgvReturnDate }}
                            </td>
                        </ng-container>

                        <!-- Etat -->
                        <!--                        <ng-container *ngIf="allDisplayedColumns['cgvStateNum']" matColumnDef="cgvStateNum">-->
                        <!--                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">Etat</th>-->
                        <!--                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">-->
                        <!--                                {{ item.cgvStateNum }}-->
                        <!--                            </td>-->
                        <!--                        </ng-container>-->

                        <!-- CA F2/F3/F5 -->
                        <ng-container *ngIf="allDisplayedColumns['f2f3f5CA']" matColumnDef="f2f3f5CA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA
                                F2/F3/F5
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.f2f3f5CA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <!-- CA Regional -->
                        <ng-container *ngIf="allDisplayedColumns['regionCA']" matColumnDef="regionCA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA
                                Régional
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.regionCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <!-- CA Thematique -->
                        <ng-container *ngIf="allDisplayedColumns['thematicCA']" matColumnDef="thematicCA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA
                                Thématique
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.thematicCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <!-- CA Parrainage -->
                        <ng-container *ngIf="allDisplayedColumns['sponsorshipFtpCA']" matColumnDef="sponsorshipFtpCA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA
                                Parrainage FTP
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipFtpCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <!-- CA Parrainage Thématique -->
                        <ng-container *ngIf="allDisplayedColumns['sponsorshipThematicCA']"
                                      matColumnDef="sponsorshipThematicCA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA
                                Parrainage Thématique
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipThematicCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <!-- CA Parraiange Reg -->
                        <ng-container *ngIf="allDisplayedColumns['sponsorshipRegCA']" matColumnDef="sponsorshipRegCA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA
                                Parrainage Reg
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipRegCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <!-- CA Parrainage SO Reach -->
                        <ng-container *ngIf="allDisplayedColumns['sponsorshipSoReachCA']"
                                      matColumnDef="sponsorshipSoReachCA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA
                                Parrainage SOReach
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipSoReachCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['sponsorshipWebCA']" matColumnDef="sponsorshipWebCA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA
                                Parrainage Web
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipWebCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['webCA']" matColumnDef="webCA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA Web
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.webCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['OIWebCA']" matColumnDef="OIWebCA">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">CA OI
                                Web
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.OIWebCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['open']" matColumnDef="open"
                                      (click)="onIconClick($event)">
                            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-center-align font-ns">
                                Visualiser
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                <mat-icon (click)="onIconClick(item)">remove_red_eye</mat-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </div>

                <ng-template #loading>
                    <div class="spinner-container min-height-50">
                        <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
